export const HeaderTable = ["Parameter", "Value", "Example"];

export const HeaderBodyTable = [
  {
    Parameter: "apikey",
    Value: "Generated Api Key",
    Example: "jlralaOldPgNxckYQ8HlTEqTiqQb7v (API key provided from our end)",
  },
];
